export default (el, index) => {
  const submenuLink = el.querySelector(".js-mobile-nav-top-link");
  const submenu = el.querySelector(".js-mobile-nav-submenu");
  const submenuLinks = document.querySelectorAll(".js-mobile-nav-top-link");
  // const submenus = document.querySelectorAll(".js-mobile-nav-submenu");
  const backBtn = document.querySelector(".js-mobile-nav-back-btn");
  backBtn.style.visibility = "hidden";

  submenuLink.addEventListener("click", (e) => {
    backBtn.style.visibility = "visible";
    handleSubmenu(submenuLinks, submenu);
  });

  backBtn.addEventListener("click", (e) => {
    const activeSubmenu = document.querySelector(
      ".mobile-nav__submenu-container--display",
    );

    if (activeSubmenu) {
      backBtn.style.visibility = "hidden";
      handleSubmenu(submenuLinks, activeSubmenu);
    }
  });

  function handleSubmenu(submenuLinks, submenu) {
    if (submenu.classList.contains("mobile-nav__submenu-container--display")) {
      submenu.classList.remove("mobile-nav__submenu-container--display");
      ariaExpandToggle(submenuLink, submenu);
    } else {
      submenu.classList.add("mobile-nav__submenu-container--display");
      ariaExpandToggle(submenuLink, submenu);
    }

    submenuLinks.forEach((link, i) => {
      if (link.classList.contains("mobile-nav__top-link--hidden")) {
        link.classList.remove("mobile-nav__top-link--hidden");
      } else {
        link.classList.add("mobile-nav__top-link--hidden");
      }
    });
  }

  function ariaExpandToggle(menuLink, menu) {
    if (menuLink.hasAttribute("aria-expanded")) {
      if (menuLink.getAttribute("aria-expanded") === "false") {
        menuLink.setAttribute("aria-expanded", true);
      } else {
        menuLink.setAttribute("aria-expanded", false);
      }
    }

    if (menu.hasAttribute("aria-hidden")) {
      if (menu.getAttribute("aria-hidden") === "true") {
        menu.setAttribute("aria-hidden", false);
      } else {
        menu.setAttribute("aria-hidden", true);
      }
    }
  }
};
